export default "__VITE_ASSET__23e05a83__"